import React, { useState } from "react";
import OrderTable from "../components/OrderTable";


const dummyData = Array.from({ length: 45 }, (_, i) => ({
  orderId: `order ${i + 1}`,
  customer_name: `Steve Smith ${i + 1}`,
  amount: `${i + 1}00000`,
  payment_status: `Paid`,
  order_status:`Confirmed`
}));

const ITEMS_PER_PAGE = 10;

const Orders = () => {
  const [currentPage, setCurrentPage] = useState(1);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
  const endIndex = startIndex + ITEMS_PER_PAGE;

  return (
    <div className="flex flex-col w-full gap-4">
  {/* Header */}
  <div className="bg-gray-700 p-3 w-full">
    <h1 className="font-bold text-[1.3rem]">Manage Orders</h1>
  </div>

  {/* Content */}
  <div className="p-2 w-full bg-gray-700">
    <OrderTable
      data={dummyData.slice(startIndex, endIndex)}
      currentPage={currentPage}
      totalPages={Math.ceil(dummyData.length / ITEMS_PER_PAGE)}
      onPageChange={handlePageChange}
    />
  </div>
</div>

  );
};

export default Orders;
